/**
 * Split engineering descriptions into pagination-safe chunks at paragraph /
 * numbered-list / blank-line boundaries. Does not alter source data.
 */
export function splitDescriptionChunks(raw: string | null | undefined): string[] {
  const text = String(raw ?? '').replace(/\r\n/g, '\n').trim();
  if (!text) return [''];

  // Prefer blank-line paragraphs first.
  const paragraphs = text.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
  const chunks: string[] = [];

  for (const para of paragraphs) {
    const lines = para.split('\n');
    let buf: string[] = [];

    const flush = () => {
      const joined = buf.join('\n').trim();
      if (joined) chunks.push(joined);
      buf = [];
    };

    for (const line of lines) {
      const trimmed = line.trimEnd();
      const startsNumbered = /^\d+[.)]\s+/.test(trimmed.trim());
      const startsBullet = /^[-*•]\s+/.test(trimmed.trim());
      if ((startsNumbered || startsBullet) && buf.length > 0) {
        flush();
      }
      buf.push(trimmed);
    }
    flush();
  }

  return chunks.length > 0 ? chunks : [text];
}

/** Approximate wrapped line count for measurement estimates. */
export function estimateWrappedLineCount(text: string, charsPerLine: number): number {
  const lines = String(text || '').split('\n');
  let total = 0;
  for (const line of lines) {
    const len = line.length || 1;
    total += Math.max(1, Math.ceil(len / Math.max(8, charsPerLine)));
  }
  return Math.max(1, total);
}
